export const colors = {
  primary: "#FF6F61", // Coral - Primary actions and highlights
  primaryHover: "#D65F50", // Darker coral for hover states
  secondary: "#F4F4F4", // Light Gray - Secondary background
  success: "#4CAF50", // Forest Green - Success states
  danger: "#FF3D00", // Bright Orange - Error messages
  dangerHover: "#D32F2F", // Darker red for danger button hover
  text: "#212121", // Dark Charcoal - Primary text (near black)
  textSecondary: "#757575", // Medium Gray - Secondary text and labels
  border: "#E0E0E0", // Light Gray - Borders and dividers
  white: "#FFFFFF", // Pure white for contrast
  background: "#F5F5F5", // Light Gray - Background
  secondaryBackground: "#FFFFFF", // Pure white for contrast
};

export const typography = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: {
    xs: 13,
    sm: 14,
    base: 15,
    md: 16,
    lg: 20,
    xl: 32,
  },
  fontWeight: {
    normal: 400,
    medium: 600,
    bold: 700,
  },
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
};

export const borderRadius = {
  sm: 8,
  md: 12,
  lg: 16,
};

export const transitions = {
  default: "all 0.2s ease",
};
